import React, { useState } from 'react';
import { Typography, Input, Textarea, Button } from "@material-tailwind/react";

export function EmailForm({ onBack }) {
    const [form, setForm] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('/api/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(form),
            });

            if (response.ok) {
                alert('Email sent successfully!');
                setForm({ name: '', email: '', message: '' });
                onBack();
            } else {
                alert('Failed to send email. Please try again.');
            }
        } catch (error) {
            console.error('Error sending email:', error);
            alert('Failed to send email. Please try again.');
        }
    };

    return (
        <div className="flex flex-col h-full">
            <div className="border-b p-4">
                <Typography variant="h5" className="dark:text-white">Contact Form</Typography>
            </div>

            <div className="p-4 flex-1 overflow-y-auto">
                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        type="text"
                        label="Naam"
                        required
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        className="dark:text-white"
                    />
                    <Input
                        type="email"
                        label="Email"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="dark:text-white"
                    />
                    <Textarea
                        label="Bericht"
                        required
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        className="dark:text-white"
                        rows={4}
                    />
                    <Button
                        type="submit"
                        className="w-full capitalize"
                    >
                        Verstuur Email
                    </Button>
                </form>
            </div>
        </div>
    );
}